import { AssetType } from "@zapier/canvas-state";

export function getIconNameByAssetType(assetType: AssetType) {
  switch (assetType) {
    case "zap":
      return "miscBoltAltFill";
    case "interface":
      return "navInterfaces";
    case "table":
      return "navTables";
    case "chatbot":
      return "navAIChatbot";
    default:
      return "miscBoltAltFill";
  }
}
